import { render, staticRenderFns } from "./definisi.vue?vue&type=template&id=300b9963"
import script from "./definisi.vue?vue&type=script&lang=js"
export * from "./definisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports